import React from 'react';
import { FREESTAR_RECOVERED_SCRIPT_ID, FREESTAR_RECOVERED_SCRIPT_SOURCE } from './freestarRecoveredScript';

/**
 * Freestar Recovered (ad-block recovery) head script.
 * PubOS Site Config → Freestar Recovered.
 */
export const FreestarRecovered: React.FC = () => (
  <script
    dangerouslySetInnerHTML={{ __html: FREESTAR_RECOVERED_SCRIPT_SOURCE }}
    data-cfasync="false"
    id={FREESTAR_RECOVERED_SCRIPT_ID}
    type="text/javascript"
  />
);
